import { getPayloadData, getIsApiPending } from '../../../selectors/travelKe/payloadCollection';
import { setExpiredAuth } from '../../../actions/travelKe/quote';
import {
    apiTransitionBankDetails,
    bankDetailsSuccess,
    bankDetailsFailure,
} from '../../../actions/travelKe/payments';
import { getAccessToken, getIsBankDetailsAPiPending } from '../../../selectors/travelKe/payments';
import axios from 'axios';
import { getPremiumCalculation } from '../../../selectors/travelKe/quote';

export const bankDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsBankDetailsAPiPending(store.getState())) {
            store.dispatch(apiTransitionBankDetails.pending());
            try {
                const resp = await confirmInsuranceOrder(store.getState());
                store.dispatch(bankDetailsSuccess(resp.data));
                store.dispatch(apiTransitionBankDetails.success());
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionBankDetails.failure());
                //store.dispatch(BankDetailsFailure(e));
            }
        }
    })();
    return next(action);
};

const BankDetailsPayload = (state) => {
    const payloadData = getPremiumCalculation(state);
    const quoteId = payloadData?.value?.id;
    const payload = {
        quoteId,
    };
    // Change payload here
    return {
        ...payload,
    };
};

const confirmInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ke/bank-details';
        const response = await axios.post(url, BankDetailsPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        // if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        //     store.dispatch(setExpiredAuth(true));
        // }
        console.error(e);
        throw e;
    }
};
